import React from 'react';
import { Box, IconButton, Paper, Typography } from '@mui/material';
import { OrderControl } from '../OrderControl';

const DeleteIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
  </svg>
);

interface BlockWrapperProps {
  label: string;
  onDelete: () => void;
  onUp: () => void;
  onDown: () => void;
  disabledUp?: boolean;
  disabledDown?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}

export const BlockWrapper: React.FC<BlockWrapperProps> = ({
  label,
  onDelete,
  onUp,
  onDown,
  disabledUp = false,
  disabledDown = false,
  disabled = false,
  children,
}) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              display: 'block',
              mb: 1,
              textTransform: 'uppercase',
              fontWeight: 600,
            }}
          >
            {label}
          </Typography>
          {children}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0.5,
            ml: 1,
            flexShrink: 0,
          }}
        >
          <OrderControl
            onUp={onUp}
            onDown={onDown}
            disabledUp={disabledUp || disabled}
            disabledDown={disabledDown || disabled}
          />
          <IconButton
            size="small"
            onClick={onDelete}
            color="error"
            disabled={disabled}
            aria-label="Удалить блок"
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
};
